const locationChangeListeners = [];

/**
 * @param {function} listener - a callback to trigger on location change
 * @returns cleanup function
 */
export function addLocationChangeConfirmationListener(listener) {
  locationChangeListeners.push(listener);
  return () => {
    const index = locationChangeListeners.findIndex(element => element === listener);
    if (index !== -1) {
      locationChangeListeners.splice(index, 1);
    }
  };
}

export function confirmAllListeners(event) {
  return locationChangeListeners.every((callback) => callback(event));
}
